import React from 'react';
import { FaArrowsToDot, FaExpand, FaMagnifyingGlassMinus, FaMagnifyingGlassPlus, FaTruckPickup, FaList, FaBars } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectionMode, toggleSelectionMode } from '../../Store/tileSelectionSlice';
import classNames from 'classnames';
import CompareButton from './CompareButton';

interface ResultViewerImageToolBarProps {
    handleToggleSidebar: () => void;
    handleToggleResultList: () => void;
    sidebarOpen: boolean;
    resultListOpen: boolean;
    showCompareButton?: boolean;
}

export default function ResultViewerImageToolBar(props: ResultViewerImageToolBarProps) {

    const { handleToggleSidebar, handleToggleResultList, sidebarOpen, resultListOpen, showCompareButton = true } = props;
    const dispatch = useDispatch();

    const handleToggleSelectionMode = () => {
        dispatch(toggleSelectionMode())
    }

    const selectionModeOn = useSelector(selectSelectionMode)

    // TODO: Add OpenSeadragon buttons
    // https://openseadragon.github.io/examples/ui-binding-custom-buttons/
    /**
    zoomInButton:   "zoom-in",
    zoomOutButton:  "zoom-out",
    homeButton:     "home",
    fullPageButton: "full-page",
    nextButton:     "next",
    previousButton: "previous",
     */

    const selectionButtonClasses = classNames({
        "bg-amber-400": selectionModeOn,
        "hover:bg-amber-500": selectionModeOn,
        "text-white": selectionModeOn,
        "hover:bg-neutral-200 hover:dark:bg-neutral-600": !selectionModeOn,
    }, "py-2 px-4 ml-2 rounded")

    return <div className='flex flex-row gap-1 p-1 border-b border-b-neutral-300 dark:border-b-neutral-600'>
        <button className='hover:bg-neutral-200 hover:dark:bg-neutral-600 py-2 px-4 rounded w-28' onClick={handleToggleResultList}>
            <span className='flex content-center items-center text-xs'><FaList className='text-xs mt-0.5 mr-2' />{resultListOpen ? 'Hide List' : 'Show List'}</span>
        </button>
        <button className='hover:bg-neutral-200 hover:dark:bg-neutral-600 py-2 px-4 rounded w-32' onClick={handleToggleSidebar}>
            <span className='flex content-center items-center text-xs'><FaBars className='text-xs mt-0.5 mr-2' />{sidebarOpen ? 'Hide Details' : 'Show Details'}</span>
        </button>
        {showCompareButton && <CompareButton />}
        <button id="zoom-in" className='hover:bg-neutral-200 hover:dark:bg-neutral-600 py-2 px-4 rounded'>
            <span className='flex content-center items-center text-xs'><FaMagnifyingGlassPlus className='text-xs mt-0.5 mr-2' />Zoom In</span>
        </button>
        <button id="zoom-out" className='hover:bg-neutral-200 hover:dark:bg-neutral-600 py-2 px-4 rounded'>
            <span className='flex content-center items-center text-xs'><FaMagnifyingGlassMinus className='text-xs mt-0.5 mr-2' />Zoom out</span>
        </button>
        <button id="home" className='hover:bg-neutral-200 hover:dark:bg-neutral-600 py-2 px-4 rounded'>
            <span className='flex content-center items-center text-xs'><FaArrowsToDot className='text-xs mt-0.5 mr-2' />Reset</span>
        </button>
        <button id="full-page" className='hover:bg-neutral-200 hover:dark:bg-neutral-600 py-2 px-4 rounded'>
            <span className='flex content-center items-center text-xs'><FaExpand className='text-xs mt-0.5 mr-2'/></span>
        </button>
        <div className='w-80 flex items-center ml-4'>
            <input id="image-viewer-opacity" type="range" min={0} max="100" defaultValue={75} className="range range-xs" />
            <span className="text-xs whitespace-nowrap ml-2">Heatmap</span>
        </div>
        <button id="tile-mode" className={selectionButtonClasses} onClick={handleToggleSelectionMode}>
            <span className='flex content-center items-center text-xs'><FaTruckPickup className='text-xs mt-0.5 mr-2'/></span>
        </button>
    </div>
}